export const checkIfArraysOrObjectsAreEqual = (arg1: Array<any> | {}, arg2: Array<any> | {}): boolean => JSON.stringify(arg1) === JSON.stringify(arg2)
